export const ProsPlanProgramIds = 'PRSP';
